import { Action as RootAction } from '@occc-app/rootRedux/action';

import types, { State } from './types';

export const initialState: State = {
  // TODO: Change/remove data later. Using for Offer - selected Product Groups in Earning Mechanism
  data: {
    productGroups: [],
  },
};

export default function reducer(state: State = initialState, action: RootAction): State {
  switch (action.type) {
    case types.PRODUCT_GROUPS_OK:
      return {
        ...state,
        data: { ...state.data, productGroups: action.productGroups },
      };
    default:
      return state;
  }
}
